import { PROPERTY_DATA_RESULT_API } from '../constants/AppConstants';
/**
 * Service to get property data result
 * @param {string} requestId - The request ID from the initial property data request
 * @returns {Promise} - API response promise
 */
const propertyDataResultService = async (requestId, orgNodeId) => {
  try {
    const response = await fetch(`${PROPERTY_DATA_RESULT_API}/${requestId}?orgNodeId=${orgNodeId}`, {
      method: 'GET',
    });
    const json = await response.json();
    if (response.status === 202) return { ok: true, json, status: response.status };
    if (response.status !== 200) return { ok: false, json, status: response.status };
    return { ok: true, json, status: response.status };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};

export default propertyDataResultService;
